'use client';

import {operationFlowContent} from '@/lib/landing/content';
import {cardHoverClass, FadeIn, sectionBorderLight, sectionPadding, SectionContainer, SectionHeader} from './shared';

export function OperationFlowSection() {
  return (
    <section id={operationFlowContent.id} aria-labelledby="flow-heading" className={`${sectionPadding} bg-white ${sectionBorderLight} relative`}>
      <SectionContainer>
        <FadeIn>
          <SectionHeader badge="Cómo funciona" title={operationFlowContent.title} />
        </FadeIn>

        <ol className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {operationFlowContent.steps.map((step, index) => (
            <FadeIn key={step.step} delay={index * 0.1} className="h-full">
              <li className={`list-none h-full bg-kobra-bg border border-kobra-border rounded-2xl p-6 hover:border-kobra-accent/30 ${cardHoverClass}`}>
                <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-kobra-dark text-white text-sm font-bold mb-4">
                  {step.step}
                </span>
                <h3 className="text-lg font-bold text-kobra-text-dark mb-2">{step.title}</h3>
                <p className="text-sm text-kobra-text-muted leading-relaxed">{step.description}</p>
              </li>
            </FadeIn>
          ))}
        </ol>
      </SectionContainer>
    </section>
  );
}
